import { Injectable } from '@angular/core';
import { Toast, ToastController } from 'ionic-angular';

@Injectable()
export class ToastService {
    toast: Toast;

    constructor(private toastCtrl: ToastController) {}

    setToast(message: string, showCloseButton = true, cssClass = null, duration = 3000, position = 'middle') {
        // Si un Toast existe, on le supprime
        if (this.toast) {
            this.toast.dismiss();
        }
        this.toast = this.toastCtrl.create({
            message,
            duration,
            position,
            cssClass,
            showCloseButton,
            closeButtonText: 'X'
        });
        this.toast.present();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/toast.service.ts